module.exports = __webpack_public_path__ + "static/img/celoscope-3.1b5c047.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/productspic/celoscopepic/celoscope-3.jpg
// module id = Lzcb
// module chunks = 51